import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import Calculations from './Calculations'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Calculations />
  </StrictMode>,
)
